// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"4b396bed","977":"b6d92400"}[chunkId] + ".chunk.js";
};